import { supabase } from "@/integrations/supabase/client";
import {
  projectStatusProjection,
  toProjectStatus,
  type ProjectStatus,
} from "@/domains/projects/status/projectStatus";

export interface ProjectOption {
  id: number;
  name: string;
  status: ProjectStatus;
}

export interface FolderOption {
  id: number;
  folder_path: string;
}

export async function fetchProjectOptions(params: {
  orgId: string;
  buildingId: number;
}): Promise<ProjectOption[]> {
  const columns = await projectStatusProjection("id, name");
  const { data, error } = await supabase
    .from("building_projects")
    .select(columns)
    .eq("org_id", params.orgId)
    .eq("building_id", params.buildingId)
    .eq("hidden", false)
    .eq("archived", false)
    .order("name");
  if (error) throw error;
  const rows = (data ?? []) as Array<{ id: number; name: string; project_status?: string | null }>;
  return rows.map((row) => ({
    id: row.id,
    name: row.name,
    status: toProjectStatus(row.project_status),
  }));
}

export async function fetchFolderOptions(params: {
  orgId: string;
  buildingId: number;
  projectId: number;
}): Promise<FolderOption[]> {
  const { data, error } = await supabase
    .from("document_folders")
    .select("id, folder_path")
    .eq("org_id", params.orgId)
    .eq("building_id", params.buildingId)
    .eq("project_id", params.projectId)
    .eq("is_deleted", false)
    .eq("hidden", false)
    .order("folder_path");
  if (error) throw error;
  return (data ?? []) as FolderOption[];
}
